<template>
  <div>
    <label :for="labelFor" v-if="label" class="label--style">{{ label }}</label>
    <div
      class="category-select d-flex align-items-center justify-content-between m-0 px-2"
      @click="handleSearchDropDown()"
    >
      <span class="label">{{ selectLabel }}</span>
      <span><font-awesome-icon icon="fa-solid fa-angle-down" /></span>
    </div>
    <div v-if="toggleSearchDropDown" class="dropdown-box d-flex flex-column justify-content-between">
      <div>
        <div class="m-2">
          <input
            :type="type"
            :name="name"
            :placeholder="placeholder"
            :value="value"
            @input="$emit('input', $event.target.value)"
            class="dropdown-control"
          />
          <div class="d-flex justify-content-between gap-5" v-if="create && showAddOption">
            <p class="create-new-option-label" @click="callBackCreate">
              <font-awesome-icon icon="fa-solid fa-plus" />
              <span class="ms-2">Create New</span>
            </p>
            <p class="info-label flex-grow-1 mt-2">
              <font-awesome-icon icon="fa-solid fa-circle-info" />Input should be atleast 2 characters!
            </p>
          </div>
        </div>
        <hr class="divider-dp" />
      </div>
      <div class="dropdown-body">
        <p
          v-for="(item, index) in items"
          :key="index"
          class="option"
          @click="callback({ value: item.value, label: item.label })"
        >
          {{ item.label }}
        </p>
      </div>
      <div class="mx-0 dropdown-footer">
        <div class="row">
          <div class="col-4">
            <Button label="Close" @onClick="handleSearchDropDown()" class="qb-btn qb-btn-outline-sm w-100" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../components/ButtonComponent.vue";
export default {
  name: "DropDownSearchComponent",
  data() {
    return {
      toggleSearchDropDown: false,
    };
  },
  components: {
    Button,
  },
  props: {
    labelFor: {
      type: String,
    },
    label: {
      type: String,
    },
    selectLabel: {
      type: String,
    },
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    items: {
      type: Array,
    },
    type: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    create: {
      type: Boolean,
    },
    showAddOption: {
      type: Boolean,
    },
  },
  methods: {
    handleSearchDropDown() {
      this.toggleSearchDropDown = !this.toggleSearchDropDown;
    },
    callback(item) {
      this.$emit("callBackValue", item);
      this.handleSearchDropDown();
    },
    callBackCreate() {
      this.$emit("callBackCreate");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.fa-angle-down {
  color: $light-500;
}

.fa-plus {
  color: $light-500;
}

.dropdown-control {
  border: 1px solid $light-fade-200;
  border-radius: $field-border-radius;
  padding: 6px 10px;
  width: 100%;
  background-color: $light-fade-200;
  font-size: $font-size-md;
}

.create-new-option-label {
  color: $light-500;
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  margin-bottom: 0;
  margin-top: 10px;
  min-width: fit-content;

  &:hover {
    .fa-plus {
      color: $dark-300;
    }

    color: $dark-300;
    cursor: pointer;
  }
}

.info-label {
  color: $light-400;
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  margin: 0px;
  text-align: end;
}

.fa-circle-info {
  color: $light-400;
  font-size: $font-size-sm;
  margin-right: 5px;
}

.dropdown-control::placeholder {
  font-size: $font-size-md;
}

.label--style {
  font-weight: $font-weight-normal-2;
  font-size: $font-size-md;
  // margin-top: 10px;
  margin-bottom: 10px;
}

.dropdown-control:focus {
  outline: none;
}

.category-select {
  border: 1px solid rgb(222, 222, 222);
  border-radius: $field-border-radius;
  padding: 5px 0px;
  width: 100%;
}

.category-select:hover {
  background-color: $light-100;
  cursor: pointer;
}

.category-select .label {
  color: $light-600;
  font-size: $font-size-md;
  text-transform: capitalize;
}

.divider-dp {
  border: 0.5px solid $light-400;
  margin: 0px;
}

.option {
  margin: 0px;
  font-size: 15px;
  color: $dark-100;
  font-size: $font-size-md;
  padding: 6px 10px;
  text-transform: capitalize;
  border-radius: $field-border-radius;

  &:hover {
    background-color: $light-100;
    cursor: pointer;
  }
}

.dropdown-box {
  position: absolute;
  background-color: $white;
  border: 1px solid rgb(222, 222, 222);
  border-radius: $field-border-radius;
  width: 300px;
  z-index: 1;
  margin-top: -40px;
  margin-left: 0px;
  min-height: 300px;
}

.dropdown-body {
  height: 200px;
  overflow-y: auto;
  // padding: 10px;
}

.dropdown-footer {
  padding: 6px 10px;
  background-color: $light-100;
  border-bottom-left-radius: $field-border-radius;
  border-bottom-right-radius: $field-border-radius;
}
</style>
